import { isBelowiOS26 } from '@/lib/utils/iosCompat'
import { useTheme } from 'expo-router/react-navigation'
import { Stack, type NativeStackNavigationOptions } from 'expo-router'
import { Platform } from 'react-native'

export default function FormsLayout() {
  const theme = useTheme()

  return (
    <Stack
      screenOptions={{
        title: '',
        headerLargeTitle: true,
        headerShadowVisible: false,
        headerBackButtonDisplayMode: 'minimal',
        contentStyle: { backgroundColor: theme.colors.background },
        ...Platform.select<NativeStackNavigationOptions>({
          ios: {
            // Opaque header on iOS <26 desyncs RN touch/measure coordinates from the
            // visual layout after push+pop (taps land ~header-height off and get
            // suppressed by Pressability), so keep the header transparent and use a
            // blur effect for the pre-26 look.
            headerTransparent: true,
            ...(isBelowiOS26 ? { headerBlurEffect: 'systemChromeMaterial' as const } : {}),
          },
          android: {
            headerTransparent: false,
            headerStyle: { backgroundColor: theme.colors.background },
          },
        }),
      }}
    >
      <Stack.Screen name="index" options={{ title: '表单' }} />
    </Stack>
  )
}
